import { render } from "./CompDetalhamento.vue?vue&type=template&id=cbba7340&scoped=true"
import script from "./CompDetalhamento.vue?vue&type=script&lang=js"
export * from "./CompDetalhamento.vue?vue&type=script&lang=js"

import "./CompDetalhamento.vue?vue&type=style&index=0&id=cbba7340&lang=scss&scoped=true"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbba7340"]])

export default __exports__